import { axios } from './axios.js';
import { BACKEND_URL } from '/environment.js';

export const createComment = async data => {
  const res = await axios.post('/comments/add', data);
  return res.data;
};

export const getCommentAttachmentApi = async commentAttachmentId => {
  const res = await axios.get(
    `comments/commentAttacment/${commentAttachmentId}`,
  );
  return res.data;
};

// getCommentAttachment basically just returns the download URL string for the comment attachment,
// so no need for a backend call - also no need to check that the comment attachment exists because it should as we get it from the db just before
export const getCommentAttachment = commentAttachmentId => {
  return `${BACKEND_URL}api/v1/comments/commentAttacment/${commentAttachmentId}/download`;
};

export const editComment = async (commentId, data) => {
  const res = await axios.put(`/comments/${commentId}`, data);
  return res.data;
};

export const editTaskStatus = async (
  commentId,
  newTaskStatus,
  statusChangerUid,
) => {
  const res = await axios.put(
    `/comments/editStatus/${commentId}/${newTaskStatus}/${statusChangerUid}`,
  );
  return res.data;
};

export const deleteComment = async commentId => {
  const res = await axios.delete(`/comments/${commentId}`);
  return res.data;
};

export const isAdmin = async (organizationId, userId) => {
  const res = await axios.get(
    `/comments/organizationuser/${organizationId}/${userId}`,
  );
  return res.data;
};

export const getOrgMembers = async organizationId => {
  const res = await axios.get(
    `/organization/details/${organizationId}/users/get?pageIndex=0&pageSize=0`,
  );
  return res.data;
};
